
import { diemDanhActions } from "../diem-danh/diemDanhActions";
import { diemDanhTrangThaiAction } from "./diemDanhTrangThaiActions";
import { giaoVienActions } from "./giaoVienAction";
import { lopActions } from "./lopActions";
import { phongNamHocActions } from "./phongNamHocActions";
import { tietActions } from "./tietActions";
import { tuanActions } from "./tuanActions";

export const danhMucActionsWrapper = {
    lop: lopActions,
    tiet: tietActions,
    tuan: tuanActions,
    phongNamHoc: phongNamHocActions,
    giaoVien: giaoVienActions,
    trangThai: diemDanhTrangThaiAction
}